import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-webhooks',
  templateUrl: './webhooks.component.html',
  styleUrls: ['./webhooks.component.scss']
})
export class WebhooksComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
